import { bdayPost, bdayGet, bdayPut, bdayDelete } from 'services/utils';
import { queryDictToString } from 'components/utils/query';

const baseHolidaysApi = '/api/1/holidays';
const baseCalendarApi = '/api/1/calendar';
const baseReminderApi = '/api/1/reminder';
const baseRemindersApi = '/api/1/reminders';
const baseBirthdayApi = '/api/1/birthday';
const baseAnniversaryApi = '/api/1/anniversary';
const baseEventApi = '/api/1/event';

export const getHolidays = (data) => {
  const queryDictString = queryDictToString(data);
  return bdayGet(`${baseHolidaysApi}${queryDictString}`);
}
export const updateHolidays = (data) => {
  return bdayPost(`${baseHolidaysApi}`, data);
}
export const getReminder = (data) => {
  const queryDictString = queryDictToString(data);
  return bdayGet(`${baseReminderApi}${queryDictString}`);
}
export const getCalendar = (data) => {
  return bdayGet(`${baseCalendarApi}/${data.calendarId}`);
}
export const deleteReminder = (data) => {
  return bdayDelete(`${baseReminderApi}/${data.calendarId}`, data);
}
export const updateReminder = (data) => {
  return bdayPut(`${baseReminderApi}/${data.calendarId}`, data);
}
export const sendReminder = (data) => {
  return bdayPost(`${baseReminderApi}/send/${data.calendarId}`, data);
}
export const blockReminder = (data) => {
  return bdayPost(`${baseReminderApi}/block/${data.calendarId}`, data);
}
export const getReminders = (data) => {
  const queryDictString = queryDictToString(data);
  return bdayGet(`${baseRemindersApi}${queryDictString}`);
}

export const addBirthday = (data) => {
  return bdayPost(`${baseBirthdayApi}`, data);
}
export const updateBirthday = (data) => {
  return bdayPut(`${baseBirthdayApi}`, data);
}

export const addAnniversary = (data) => {
  return bdayPost(`${baseAnniversaryApi}`, data);
}
export const updateAnniversary = (data) => {
  return bdayPut(`${baseAnniversaryApi}`, data);
}

export const addEvent = (data) => {
  return bdayPost(`${baseEventApi}`, data);
}
export const updateEvent = (data) => {
  return bdayPut(`${baseEventApi}`, data);
}

export const getBirthdayRequest = (data) => {
  const queryDictString = queryDictToString(data);
  return bdayGet(`${baseBirthdayApi}/request${queryDictString}`);
}
export const addBirthdayRequest = (data) => {
  return bdayPost(`${baseBirthdayApi}/request`, data);
}
export const updateBirthdayRequest = (data) => {
  return bdayPut(`${baseBirthdayApi}/request`, data);
}
